/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";
import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { PageThumbnail } from "src/components/Shared/PageThumbnail";
import { CreationThumbnail } from "src/components/Shared/PageThumbnail/CreationThumbnail";
import { DEFAULT_THUMBNAIL_WIDTH } from "src/lib/constants";

interface Props {
  plates: BasePlate[];
  showCreateOption?: boolean;
  filterValue?: string;
}

export function ThumbnailGrid({ plates, showCreateOption, filterValue = "" }: Props) {
  const filteredPlates = plates.filter((plate) =>
    plate.snapshot.title.toLowerCase().includes(filterValue.toLowerCase())
  );
  return (
    <StyledGrid id="cy-pages-grid">
      {showCreateOption && <CreationThumbnail />}
      {filteredPlates.map((plate) => (
        <PageThumbnail
          plate={plate}
          key={plate.snapshot.id}
          filterValue={filterValue}
          wrapperStyles={{ marginBottom: "25px" }}
          truncateTitle
        />
      ))}
    </StyledGrid>
  );
}

const StyledGrid = styled.div`
  display: grid;
  /* autogen columns with a width of 120px */
  grid-template-columns: repeat(auto-fit, ${DEFAULT_THUMBNAIL_WIDTH}px);

  column-gap: 40px;
  margin-top: 25px;
  max-width: 990px;
  width: 100%;

  @media screen and (max-width: ${DEVICE.small}) {
    grid-template-columns: repeat(auto-fit, minmax(${DEFAULT_THUMBNAIL_WIDTH}px, 1fr));
  }
`;
